import { inject, Injectable } from '@angular/core';
import { FileSharingApiService } from './api/file-sharing-api.service';
import {
  DownloadSharedFileParams,
  FileSharing,
  FileSharingDetails,
  GetFileSharing,
  SendFilesToShareParams,
} from '../types/file-sharing.type';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, map } from 'rxjs';
import { Response } from '../types';

@Injectable({
  providedIn: 'root',
})
export class FileSharingService {
  private fileSharingApiService = inject(FileSharingApiService);

  fileSharingTotal = new BehaviorSubject<number>(0);

  getSharedFiles(params: GetFileSharing): Observable<FileSharing[]> {
    return this.fileSharingApiService.getSharedFiles(params).pipe(
      map(({ result }) => {
        this.fileSharingTotal.next(result?.count || 0);
        return result?.filesSharing || [];
      }),
    );
  }

  createDraft(): Observable<number> {
    return this.fileSharingApiService
      .createDraft()
      .pipe(map(({ result }) => result || 0));
  }

  sendFilesToShare(params: SendFilesToShareParams): Observable<Response<void>> {
    return this.fileSharingApiService.sendFilesToShare(params);
  }

  getFileSharingDetails(id: number): Observable<FileSharingDetails> {
    return this.fileSharingApiService
      .getFileSharingDetails(id)
      .pipe(map(({ result }) => result || ({} as FileSharingDetails)));
  }

  downloadSharedFile(
    contentName: string,
    params: DownloadSharedFileParams,
  ): Observable<boolean> {
    return this.fileSharingApiService.downloadSharedFile(contentName, params);
  }

  deleteSharedFile(params: DownloadSharedFileParams): Observable<void> {
    return this.fileSharingApiService.deleteSharedFile(params);
  }
}
